export default __webpack_public_path__ + "static/Asphalt-Driveway-Removal-94e42a2b3b3842d72f3de9f5f5589d80.jpg";